export const getters = {
    accessPoint: state => state.accessPoint,
    administrativeUsers: state => state.administrativeUsers,
    alarms: state => state.alarms,
    alertNotifications: state => state.alertNotifications,
    allMenuOptions: state => state.menuOptions,
    annotationTypes: state => state.annotationTypes,
    arls: state => state.arls,
    assignedClients: state => state.assignedClients,
    capabilities: state => state.capabilities,
    cities: state => state.cities,
    client: state => state.client,
    clients: state => state.clients,
    clientTypes: state => state.clientTypes,
    executives: state => state.executives,
    identificationTypes: state => state.identificationTypes,
    inProgress: state => !!state.activeRequests,
    isAuthenticated: state => !!state.user,
    itemTypes: state => state.itemTypes,
    loaded: state => state.loaded,
    mail: state => state.mail,
    mailTypes: state => state.mailTypes,
    months: state => state.months,
    notes: state => state.notes,
    otherClients: state => state.otherClients,
    passengerTypes: state => state.passengerTypes,
    personEntries: state => state.personEntries,
    people: state => state.people,
    petitionStatuses: state => state.petitionStatuses,
    petitionTypes: state => state.petitionTypes,
    positions: state => state.positions,
    profiles: state => state.profiles,
    restrictedVisitors: state => state.restrictedVisitors,
    selectedRound: state => state.selectedRound,
    selectedStore: state => state.selectedStore,
    selectedBodyguardService: state => state.selectedBodyguardService,
    selectedUser: state => state.selectedUser,
    shift: state => state.shift,
    structures: state => (!!state.client ? state.client.structures : []),
    structureTypes: state => state.structureTypes,
    supervisor: state => state.supervisor,
    supervisors: state => state.supervisors,
    supervisionClient: state => state.supervisionClient,
    tools: state => state.tools,
    user: state => state.user,
    userCapabilities: state => gatherCapabilties(state.user),
    vehicleEntries: state => state.vehicleEntries,
    vehicleEntryTypes: state => state.vehicleEntryTypes,
    vehicleTypes: state => state.vehicleTypes,
    visitorTypes: state => state.visitorTypes,
    years: state => state.years,
    currentEvaluation: state => state.currentEvaluation,
    currentEvaluatedUser: state => state.currentEvaluatedUser,
    menu: state => {
        if (!state.menuOptions) return []
        const allMenus = state.menuOptions.map(menuOption => menuOption.menu)
        const menu = []
        allMenus.map(item => {
            if (-1 === menu.findIndex(menu => menu.slug === item.slug)) {
                menu.push(item)
            }
        })
        return menu.sort((a, b) => a.order - b.order)
        //return state.user.profile.permissions.filter(item => item.module.slug === 'mainmenu').sort((a, b) => a.weight - b.weight);
    },
    menuOptions: state => {
        if (!state.currentMenu || !state.user) return []

        // const menu = getters.menu;

        const options = state.menuOptions.filter(
            item => item.menu.slug === state.currentMenu.slug
        )

        return options
    },
}

const gatherCapabilties = user => {
    if (!user) return []
    const profileCapabilities =
        !!user.profile && !!user.profile.capabilities
            ? user.profile.capabilities.map(cap => cap.slug)
            : []
    const positionCapabilities = !!user.position
        ? user.position.capabilities.map(cap => cap.slug)
        : []
    const userCapabilities = user.capabilities.map(item => item.slug)
    const totalCapabilities = [
        ...profileCapabilities,
        ...positionCapabilities,
        ...userCapabilities,
    ]
    return [...new Set(totalCapabilities)]
}
